"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleSheetsRemoteConfigProvider = void 0;
const google_sheets_mapper_1 = require("google-sheets-mapper");
const GoogleSheetsRemoteConfigProvider = (props) => {
    const { apiKey, sheetId } = props;
    const getRemoteConfig = async (id) => {
        const response = await (0, google_sheets_mapper_1.fetchGoogleSheetsData)({
            apiKey: apiKey,
            sheetId: sheetId,
            sheetsOptions: [{ id }],
        });
        let remoteConfig = {};
        if (response.length > 0) {
            const data = response[0].data;
            if (data.length > 0) {
                remoteConfig = data[0];
            }
        }
        const config = Object.assign({}, remoteConfig);
        return config;
    };
    return {
        getRemoteConfig,
    };
};
exports.GoogleSheetsRemoteConfigProvider = GoogleSheetsRemoteConfigProvider;
